import * as yup from 'yup';
import { PAYMENT_METHODS } from '../../utils/paymentMethods';

/** One set of rules for creating and editing an expense. */
export const expenseSchema = yup.object({
  title: yup.string()
    .required('Title is required')
    .min(3, 'Title must be at least 3 characters')
    .max(200, 'Title must be at most 200 characters'),
  amount: yup.number()
    .typeError('Amount must be a number')
    .required('Amount is required')
    .moreThan(0, 'Amount must be greater than 0')
    .max(99999999, 'Amount is too large'),
  date: yup.string()
    .required('Date is required'),
  categoryId: yup.string()
    .required('Category is required'),
  notes: yup.string()
    .max(1000, 'Notes must be at most 1000 characters'),
  method: yup.string().oneOf([...PAYMENT_METHODS]).required('How it was paid is required'),
  referenceNumber: yup.string().max(120, 'Reference is too long'),
});
